(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["signup-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const forms = document.querySelectorAll('.signup-form');

    forms.forEach((formWrapper) => {
      const input = formWrapper.querySelector('.signup-form__input');
      const checkboxWrapper = formWrapper.querySelector('.signup-checkbox');

      if (!input || !checkboxWrapper) return;

      // initially hide
      checkboxWrapper.style.display = 'none';

      const toggleCheckbox = () => {
        if (input.value.trim() !== '') {
          checkboxWrapper.style.display = 'flex'; // or 'block' based on your CSS
        } else {
          checkboxWrapper.style.display = 'none';
        }
      };

      // run on load (in case autofill)
      toggleCheckbox();

      // listen to typing
      input.addEventListener('input', toggleCheckbox);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
